import React, { useEffect, useState } from 'react';

const campoLargo = (campo) => (campo.valor || '').length > 90;

const AdminFichaEditor = ({ usuarioNombre, ficha, cargando, error, aviso, guardando, onClose, onSave }) => {
  const [local, setLocal] = useState(ficha);
  const [activa, setActiva] = useState('datos');

  useEffect(() => {
    setLocal(ficha);
    const siguientes = (ficha && ficha.secciones) || [];

    if (siguientes.length > 0) {
      setActiva(siguientes[0].id);
    }
  }, [ficha]);

  const secciones = (local && local.secciones) || [];
  const seccion = secciones.find((item) => item.id === activa) || secciones[0];

  const actualizarCampo = (seccionId, indiceCampo, valor, enFila, indiceFila) => {
    setLocal((actual) => {
      if (!actual) {
        return actual;
      }

      return {
        ...actual,
        secciones: actual.secciones.map((item) => {
          if (item.id !== seccionId) {
            return item;
          }

          if (enFila) {
            return {
              ...item,
              filas: item.filas.map((fila, filaIndex) =>
                filaIndex === indiceFila
                  ? fila.map((campo, campoIndex) =>
                      campoIndex === indiceCampo ? { ...campo, valor } : campo
                    )
                  : fila
              ),
            };
          }

          return {
            ...item,
            campos: item.campos.map((campo, campoIndex) =>
              campoIndex === indiceCampo ? { ...campo, valor } : campo
            ),
          };
        }),
      };
    });
  };

  const dibujarCampo = (campo, indiceCampo, enFila, indiceFila) => (
    <label
      key={(enFila ? 'fila-' + indiceFila + '-' : '') + campo.etiqueta + '-' + indiceCampo}
      className={'admin-planilla-field' + (campoLargo(campo) ? ' admin-planilla-field--wide' : '')}
    >
      <span>{campo.etiqueta}</span>
      {campoLargo(campo) ? (
        <textarea
          className="profile-ficha-input"
          rows={4}
          value={campo.valor || ''}
          onChange={(event) => actualizarCampo(seccion.id, indiceCampo, event.target.value, enFila, indiceFila)}
        />
      ) : (
        <input
          className="profile-ficha-input"
          type="text"
          value={campo.valor || ''}
          onChange={(event) => actualizarCampo(seccion.id, indiceCampo, event.target.value, enFila, indiceFila)}
        />
      )}
    </label>
  );

  return (
    <div className="admin-pre-overlay" role="presentation">
      <div className="admin-pre-panel admin-pre-panel--planilla" role="dialog" aria-modal="true">
        <div className="admin-pre-bar">
          <h2>Ficha de {usuarioNombre}</h2>
          <button type="button" className="admin-pre-close" onClick={onClose} aria-label="Cerrar">
            ×
          </button>
        </div>
        <p className="admin-muted">Los cambios quedan en la ficha de Beyond y en la reseña de la agenda.</p>
        {error ? (
          <div className="admin-alert admin-alert--error" role="alert">
            {error}
          </div>
        ) : null}
        {aviso ? (
          <div className="admin-alert admin-alert--success" role="status">
            {aviso}
          </div>
        ) : null}
        {cargando ? <p className="admin-muted">Cargando ficha…</p> : null}
        {!cargando && local && seccion ? (
          <>
            <div className="admin-planilla-tabs" role="tablist">
              {secciones.map((item, index) => (
                <button
                  key={item.id}
                  type="button"
                  className={'admin-planilla-tab' + (seccion.id === item.id ? ' admin-planilla-tab--active' : '')}
                  onClick={() => setActiva(item.id)}
                >
                  {index + 1}. {item.titulo}
                </button>
              ))}
            </div>
            <div className="admin-planilla-body">
              {(seccion.campos || []).length > 0 ? (
                <div className="admin-planilla-grid">
                  {(seccion.campos || []).map((campo, indiceCampo) => dibujarCampo(campo, indiceCampo, false))}
                </div>
              ) : null}
              {(seccion.filas || []).map((fila, indiceFila) => (
                <div key={seccion.id + '-' + indiceFila} className="admin-planilla-card">
                  <div className="admin-planilla-grid">
                    {fila.map((campo, indiceCampo) => dibujarCampo(campo, indiceCampo, true, indiceFila))}
                  </div>
                </div>
              ))}
              {(seccion.campos || []).length === 0 && (seccion.filas || []).length === 0 ? (
                <p className="admin-muted">Sin datos en esta sección.</p>
              ) : null}
            </div>
            <button
              type="button"
              className="admin-btn admin-btn--primary"
              disabled={guardando}
              onClick={() => onSave(local)}
            >
              {guardando ? 'Guardando…' : 'Guardar ficha'}
            </button>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default AdminFichaEditor;
